import { Routine } from 'redux-saga-routines';
import { call, put, takeEvery, all } from 'redux-saga/effects';
import { getCurrentUser } from '../services/authService';
import { fetchCurrentUserRoutine } from '../routines/user';
import { fetchOwnersRoutine } from '../containers/OwnerList/routines';
import { getOwners } from '../services/userService';
import { setWorkspaceDataRoutine } from '../routines/workspace';

function* fetchUserRequest() {
  try {
    const { workspace, ...rest } = yield call(getCurrentUser);
    yield put(fetchCurrentUserRoutine.success(rest));
    yield put(setWorkspaceDataRoutine.trigger(workspace));
  } catch (error) {
    yield put(fetchCurrentUserRoutine.failure(error));
  }
}

function* fetchOwnersRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getOwners, payload);
    const data = {
      ...response,
      reset: !payload.from
    };
    yield put(fetchOwnersRoutine.success(data));
  } catch {
    yield put(fetchOwnersRoutine.failure());
  }
}

function* watchFetchUserRequest() {
  yield takeEvery(fetchCurrentUserRoutine.TRIGGER, fetchUserRequest);
}

function* watchFetchOwnersRequest() {
  yield takeEvery(fetchOwnersRoutine.TRIGGER, fetchOwnersRequest);
}

export default function* userSaga() {
  yield all([
    watchFetchUserRequest(),
    watchFetchOwnersRequest()
  ]);
}
